import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.32 2.58a49.3 49.3 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93v15.492a.75.75 0 0 1-1.085.671L12 18.091l-7.165 3.582a.75.75 0 0 1-1.085-.67V5.508c0-1.47 1.073-2.755 2.57-2.93M12 3.752q-2.795.002-5.507.318c-.704.081-1.243.693-1.243 1.44v14.279l6.415-3.208a.75.75 0 0 1 .67 0l6.415 3.208V5.509c0-.746-.54-1.358-1.243-1.44A48 48 0 0 0 12 3.753",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }